<template>
	<div class="row ficha" v-on:dblclick="getDetalles()" v-bind:id="'ficha_' + data.name.toLowerCase().replace(' ', '_')">
		<div class="col-12">
			<div class="ficha-btn">
				<b-dropdown class="btnMenuFicha" size="sm" variant="link" toggle-class="boton text-decoration-none" toggle-tag="a" no-caret>
					<template #button-content>
						<i class="fas fa-cog fa-fw" style="color: black" />
					</template>
					<b-dropdown-item class="menu" @click="facturar('masivo')">Facturar Masivo</b-dropdown-item>
					<b-dropdown-item class="menu" @click="facturar('coniva')">Facturar con IVA</b-dropdown-item>
					<b-dropdown-item class="menu" @click="facturar('unoxuno')">Facturar 1 x 1</b-dropdown-item>
				</b-dropdown>
			</div>
			<div class="ficha-info">
				<div><b>Grupo:</b> {{ data.name }}</div>
				<div><b>Documentos:</b> {{ data.count }}</div>
				<div><b>Monto:</b> {{ Intl.NumberFormat('es-CL').format(data.monto) }}</div>
			</div>
		</div>
	</div>
</template>
<script lang="ts">

	export default 
	{
		name: "Ficha",
		props: {
			id: Number,
			data: {},
			onFacturar: Function,
		},
		methods: {

			getDetalles() {

				var tipo = this.data.name.toLowerCase().replace(" ", "_")

				if (this.onFacturar)
					this.onFacturar("detalle", tipo)
			},

			facturar(tipo) {

				var data = this.data.name.toLowerCase()

				if (this.onFacturar)
					this.onFacturar(tipo, data)
			},
	},
}
</script>
<style scoped>

	.ficha {
		border: 1px solid lightgray;
		border-radius: 6px;	
		margin-bottom: 5px;
		background-color: white;
		user-select: none;
		-moz-user-select: none;
		-webkit-user-select: none;
	}

	.ficha:hover {
		cursor: pointer;
	}

	.ficha-btn {
		width: 100%;
		text-align: right;
	}

	.ficha-info {
		width: 100%;
		padding-bottom: 5px;
	}

	.ficha-activa {
		border: 2px solid #475a6b;
	}

</style>
